export const TILE_POSITIONS = {
    BOTTOM_LEFT: 'bottom-left',
    CENTER_LEFT: 'center-left',
    BOTTOM_RIGHT: 'bottom-right',
    CENTER_RIGHT: 'center-right',
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    CENTER: 'center',
}

export const positions = [
    TILE_POSITIONS.BOTTOM_LEFT,
    TILE_POSITIONS.CENTER_LEFT,
    TILE_POSITIONS.BOTTOM_RIGHT,
    TILE_POSITIONS.CENTER_RIGHT,
    TILE_POSITIONS.TOP_LEFT,
    TILE_POSITIONS.TOP_RIGHT,
]

export const PRE_CLASS_COPY_LIST = [
    'On time is late. Early is on time.',
    "While you're waiting, stay hydrated.",
    "Guess who's come first!",
    'Hurray! You came first!',
]
